import { ConsoleLogger, L10nBase, QueryBus } from '@skylab-shared/core';
import { ReportPrintQuery, ReportPrintResult } from './queries/report-print.query-base';


export class ReportPrinterServiceBase {
    private readonly logger = new ConsoleLogger(this.constructor.name);

    public constructor(
        private readonly queryBus: QueryBus,
        private readonly l10n: L10nBase) { }

    public async printAsync(query: ReportPrintQuery<ReportPrintResult>): Promise<void> {
        if (query.parameters.compress) {
            return this.donwloadAsync(query);
        }

        const newWindow = this.openNewWindow();
        if (!newWindow) {
            this.logger.error('Failed to open a new window');
            return;
        }
        newWindow.blur();

        window.focus();

        try {
            const response = await this.queryBus.queryAsync(query);

            newWindow.location.href = response.url;
            newWindow.focus();
        } catch (err) {
            newWindow.close();

            this.logger.error(err);
        }
    }

    private async donwloadAsync(query: ReportPrintQuery<ReportPrintResult>): Promise<void> {
        try {
            const response = await this.queryBus.queryAsync(query);
            window.location.href = response.url;
        } catch (err) {
            this.logger.error(err);
        }
    }

    private openNewWindow(): Window | null {
        const newWindow = window.open('about:blank', '_blank');
        if (newWindow) {
            newWindow.document.write(this.l10n._T('business.report-printer.loading'));
        }
        return newWindow;
    }
}
